import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Scissors, QrCode } from 'lucide-react';

export function RemnantsTab({ remnants, showQR, onConsume }) {
  var readyRemnants = remnants.filter(function(r) { return r.status === 'ready_for_reuse'; });
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Scissors size={20} />Remnant Registry
        </CardTitle>
      </CardHeader>
      <CardContent>
        {readyRemnants.length === 0 ? (
          <div className="h-48 flex flex-col items-center justify-center text-muted-foreground">
            <Scissors size={48} className="mb-4 opacity-50" />
            <p>No remnants available</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-4">
            {readyRemnants.map(function(r) {
              return (
                <Card key={r.id} className="border-l-4 border-l-orange-500">
                  <CardContent className="p-4">
                    <div className="flex justify-between items-start mb-2">
                      <span className="font-mono text-sm font-medium">{r.remnant_id}</span>
                      <Button variant="ghost" size="sm" onClick={function() { showQR('remnant', r.remnant_id, r.remnant_id); }}>
                        <QrCode size={14} />
                      </Button>
                    </div>
                    <div className="text-xl font-bold text-orange-600 mb-2">{r.length_mm} mm</div>
                    <div className="text-xs text-muted-foreground mb-3">{r.parent_item_name}</div>
                    <Button variant="outline" size="sm" className="w-full" onClick={function() { onConsume(r.remnant_id); }}>
                      Mark Consumed
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
